module.exports = __webpack_public_path__ + "img/4748f83.png";